let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("iWKl1")).then(() => parcelRequire('dqNU1'));